import { Component, OnInit, ViewChild } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../services/user.service';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';

import { ModalProfileComponent } from '../modal-profile/modal-profile.component';
import { NotificationsService } from '../services/notifications.service';
import { ModalNotificationComponent } from '../modal-notification/modal-notification.component';
import { INotification } from '../interfaces/notification';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective

  currentUser: any;
  currentLanguage: string;
  sIndex: number = null;
  logoImage: any = require("../image/logo/Amodto_logo.png");
  homeImage: any = require("../image/navbar/backHomeIcon.svg");
  summaryImage: any = require("../image/navbar/summary.svg");
  analysisImage: any = require("../image/navbar/analysis.svg");
  roiImage: any = require("../image/navbar/roi.svg");
  mdiImage: any = require("../image/navbar/mdi.svg");
  pprImage: any = require("../image/navbar/ppr.svg");

  oldLocal = localStorage.getItem('localUser');
  localModules: any;
  activeModules: any;

  messages: Array<INotification>;
  countUnreadNotifies: number;

  homePage: Boolean;

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private translate: TranslateService,
    private userService: UserService,
    private toastr: ToastrService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private notificationService: NotificationsService,
    private sanitizer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon("back", this.domSanitizer.bypassSecurityTrustResourceUrl(this.homeImage))
    this.matIconRegistry.addSvgIcon("all", this.domSanitizer.bypassSecurityTrustResourceUrl(this.summaryImage))
    this.matIconRegistry.addSvgIcon("Analysis", this.domSanitizer.bypassSecurityTrustResourceUrl(this.analysisImage))
    this.matIconRegistry.addSvgIcon("MDI", this.domSanitizer.bypassSecurityTrustResourceUrl(this.mdiImage))
    this.matIconRegistry.addSvgIcon("PPR", this.domSanitizer.bypassSecurityTrustResourceUrl(this.pprImage))
    this.matIconRegistry.addSvgIcon("ROI", this.domSanitizer.bypassSecurityTrustResourceUrl(this.roiImage))
  }

  ngOnInit() {
    this.homePage = this.router.url === '/home';
    if (this.homePage) this.logoImage = require("../image/logo/Amodto_Trasparent.png");

    this.localModules = localStorage.getItem('localModules');
    this.activeModules = JSON.parse(this.localModules);

    this.messages = new Array<INotification>();
    this.getLatestNotify(false);
    setInterval(() => this.getLatestNotify(true), 60000);
    this.getUser();
  }

  LogOut() {
    localStorage.removeItem('localUser');
    localStorage.removeItem('localLanguage');
    localStorage.removeItem('localModules');
    localStorage.removeItem('localFacilities');
    localStorage.removeItem('localID');
    localStorage.removeItem('localTags');
    localStorage.removeItem('localIDElaboration');
    localStorage.removeItem('localStateAnalysis');
    localStorage.removeItem('localSurveyCompiled');
    this.router.navigate(['/']);
  }

  //Api return Current User
  getUser() {
    var itemLocal = JSON.parse(this.oldLocal);
    var UserName = itemLocal.userName;

    this.userService.getUsers(UserName).subscribe((data: any) => {
      this.currentUser = data;
      if (this.currentUser.ProfileImg) {
        this.userService.downloadImgProfile(this.currentUser.Id).subscribe(res => {
          this.currentUser.ProfileImgURL = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + res);
        });
      } else this.currentUser.ProfileImgURL = '../../assets/image/Profile.png';
    })
  }

  openModalProfile() {
    const modalRef = this.modalService.open(ModalProfileComponent, { centered: true });
    modalRef.componentInstance.userLogged = this.currentUser;
  }

  openModalNotification(message: INotification) {
    const lastStatus = message.IsRead;
    const modalRef = this.modalService.open(ModalNotificationComponent, { centered: true });
    modalRef.componentInstance.notification = message;
    modalRef.result.then(() => {
      if (message.IsRead != lastStatus) {
        this.countUnreadNotifies += (message.IsRead) ? -1 : 1;
      }
    });
  }

  getLatestNotify(showToast: boolean) {
    this.messages = new Array<INotification>();
    this.notificationService.getLatestNotify().subscribe(data => {
      this.countUnreadNotifies = data.CountUnreadNotifies;
      if (data.Latest){
        this.messages = data.Latest;
      }
      if(showToast && data.ToasterUnshowed && Object.keys(data.ToasterUnshowed).length > 0) {
        for (let key in data.ToasterUnshowed) {
          let element = data.ToasterUnshowed[key];
          var message = element.length > 80 ? (element.substr(0, 80) + '...') : element;
          this.toastr.info(message, null, {
            positionClass: 'toast-top-left',
            timeOut: 2000
          });
        }
      }
    });
  }

  showAllNotifications() {
    this.router.navigate(['/notifications']);
  }
}
